












import InputField from "./InputField";
const Cleave = require("vue-cleave-component");

export default {
    name: "TimeInput",
    components: { InputField, Cleave },
    props: {
        label: String,
        value: String,
        disabled: Boolean,
    },
    data() {
        return {
            editString: "",
            options: {
                time: true,
                timePattern: ["h", "m"],
                delimiter: "h",
            },
        };
    },
    created() {
        this.editString = this.value;
    },
    watch: {
        editString: function () {
            this.$emit("input", this.editString);
        },
        value: function () {
            this.editString = this.value;
        },
    },
};
